const Reason = Object.freeze({
  PLANNING_TO_SELL: 'PLANNING_TO_SELL',
  PRICE_TREND: 'PRICE_TREND',
  NEED_PROPERTY_BEFORE_SELLING: 'NEED_PROPERTY_BEFORE_SELLING',
  HERITAGE: 'HERITAGE',
  BUYING_INTEREST: 'BUYING_INTEREST',
})

export default Reason
